import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitPerformanceIpptResultsMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitIpptResultInput;
}>;


export type SubmitPerformanceIpptResultsMutation = (
  { __typename: 'Mutation' }
  & { submitIpptResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitIpptResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'PerformanceResult' }
      & IpptAssessmentResultFragment
    )> }
  ) }
);

export type IpptAssessmentResultFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'FinSwimResult' } | (
    { __typename: 'IpptResult' }
    & IpptResultDataFragment
  ) | { __typename: 'March20kmResult' } | { __typename: 'SocResult' } | { __typename: 'WeightResult' } }
);

export type IpptResultDataFragment = (
  { __typename: 'IpptResult' }
  & Pick<SchemaTypes.IpptResult, 'pushUps' | 'sitUps' | 'runTimeSec' | 'points' | 'pullUps'>
);

export const IpptResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment IpptResultData on IpptResult {
  pushUps
  sitUps
  runTimeSec
  points
  pullUps
}
    `;
export const IpptAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment IpptAssessmentResult on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on IpptResult {
      ...IpptResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitPerformanceIpptResultsDocument = /*#__PURE__*/ gql`
    mutation SubmitPerformanceIpptResults($input: SubmitIpptResultInput!) {
  submitIpptResult(input: $input) {
    ... on SubmitIpptResultSuccessfulResponse {
      result {
        ...IpptAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${IpptAssessmentResultFragmentDoc}
${IpptResultDataFragmentDoc}`;
export type SubmitPerformanceIpptResultsMutationFn = Apollo.MutationFunction<SubmitPerformanceIpptResultsMutation, SubmitPerformanceIpptResultsMutationVariables>;

/**
 * __useSubmitPerformanceIpptResultsMutation__
 *
 * To run a mutation, you first call `useSubmitPerformanceIpptResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPerformanceIpptResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPerformanceIpptResultsMutation, { data, loading, error }] = useSubmitPerformanceIpptResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPerformanceIpptResultsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPerformanceIpptResultsMutation, SubmitPerformanceIpptResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPerformanceIpptResultsMutation, SubmitPerformanceIpptResultsMutationVariables>(SubmitPerformanceIpptResultsDocument, options);
      }
export type SubmitPerformanceIpptResultsMutationHookResult = ReturnType<typeof useSubmitPerformanceIpptResultsMutation>;
export type SubmitPerformanceIpptResultsMutationResult = Apollo.MutationResult<SubmitPerformanceIpptResultsMutation>;
export type SubmitPerformanceIpptResultsMutationOptions = Apollo.BaseMutationOptions<SubmitPerformanceIpptResultsMutation, SubmitPerformanceIpptResultsMutationVariables>;